<ng-container *transloco="let t">
  <div style="display: flex; gap: 8px; margin-top: 24px">
    @for(option of options; track option){

    <mat-checkbox
      [(ngModel)]="option.checked"
      (change)="onOptionChange(option.value)"
    >
      {{ t(option.viewValue )}}
    </mat-checkbox>
    }
  </div>
</ng-container>
